import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';

const getTier = fco => {
  if (fco < 51) return '1-50';
  if (fco < 101) return '51-100';
  if (fco < 201) return '101-200';
  if (fco < 351) return '201-350';
  return '351+';
};

async function getMSA(parms) {
  const {
    businessName,
    phone,
    businessEmail,
    firstName,
    lastName,
    billingAddress,
    billingAddress2,
    billingCity,
    billingCountry,
    billingState,
    billingZipCode,
    selectedCard,
    devicePrice,
    shippingFee,
    fireCode,
    fireCodePrice,
    shippingATTN,
    billingPlan,
  } = parms;

  const isTrial = selectedCard.id === 'package_1';
  const freeDevice = fireCode && !isTrial;
  const deviceFinalPrice = freeDevice ? 0 : devicePrice;
  const today = new Date();
  const contractStartDate = new Date();
  const contractEndDate = new Date();
  contractEndDate.setMonth(contractStartDate.getMonth() + 12);
  const rollOutDate = new Date();
  rollOutDate.setDate(contractStartDate.getDate() + 30);
  const contactInfo = `${firstName} ${lastName}`;
  const contactBillingAddress = `${billingAddress} ${billingAddress2}, ${billingCity}, ${billingState}, ${billingZipCode}, ${billingCountry}`;
  const packageName = `${selectedCard.title} Package`;
  const packagePrice = `$${selectedCard.price}`;
  const otherChargesTotal = deviceFinalPrice + shippingFee;
  const totalOrder = otherChargesTotal + selectedCard.price;
  const packageQty = `1`;
  const existingPdfBytes = await fetch(process.env.REACT_APP_MSA_TEMPLATE_URL).then(res => res.arrayBuffer());
  const isMonthlySubscription = billingPlan === 'monthly';

  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const secondPage = pages[1];
  const thirdPage = pages[2];
  const print = [];

  // BUSINESS NAME
  print.push({ page: firstPage, text: businessName, x: 174, y: 131, size: 20, color: rgb(0.12, 0.26, 0.36) });
  print.push({ page: firstPage, text: businessName, x: 149, y: 174, color: rgb(0.12, 0.26, 0.36) });
  print.push({ page: firstPage, text: businessName, x: 230, y: 307, color: rgb(0.12, 0.26, 0.36) });

  // CUSTOMER INFORMATION
  // Company Name
  print.push({ page: firstPage, text: businessName, x: 155, y: 492.5, size: 10 });
  // Billing Address
  print.push({ page: firstPage, text: contactBillingAddress, x: 155, y: 508, size: 10 });
  // Primary Contact
  print.push({ page: firstPage, text: contactInfo, x: 155, y: 523, size: 10 });
  // Primary Email
  print.push({ page: firstPage, text: businessEmail, x: 155, y: 538, size: 10 });
  // Primary Phone
  print.push({ page: firstPage, text: phone, x: 155, y: 552, size: 10 });
  // Billing Contact
  print.push({ page: firstPage, text: contactInfo, x: 155, y: 567, size: 10 });
  // Billing Email
  print.push({ page: firstPage, text: businessEmail, x: 155, y: 581, size: 10 });
  // Fulfillment Contact
  print.push({ page: firstPage, text: shippingATTN, x: 155, y: 595, size: 10 });
  // Fulfillment Email
  print.push({ page: firstPage, text: businessEmail, x: 155, y: 609, size: 10 });

  // DATES
  if (isTrial) {
    contractStartDate.setDate(contractStartDate.getDate() + 45);
    contractEndDate.setDate(contractEndDate.getDate() + 45);
    rollOutDate.setDate(rollOutDate.getDate() + 45);
  }

  // Contract Start Date
  print.push({ page: secondPage, text: contractStartDate.toLocaleDateString(), x: 218, y: 142 });
  // Contract End Date
  print.push({ page: secondPage, text: contractEndDate.toLocaleDateString(), x: 218, y: 157 });
  // Subscription Term
  print.push({ page: secondPage, text: 'Annual', x: 218, y: 170 });
  // Order Roll-Out Deadline
  print.push({ page: secondPage, text: rollOutDate.toLocaleDateString(), x: 218, y: 185 });

  // SOFTWARE LICENSE RECURRING FEES
  if (fireCode) {
    const description = {
      page: secondPage,
      text: isTrial
        ? `UPshow Professional Pilot* (${today.toLocaleDateString()} - ${contractStartDate.toLocaleDateString()})`
        : 'UPshow Professional Package',
      x: 40,
      y: 298,
    };
    const unitPrice = { page: secondPage, text: isTrial ? '$0' : packagePrice, x: 394, y: 298 };
    const total = { page: secondPage, text: isTrial ? '$0' : packagePrice, x: 520, y: 298 };

    print.push(description);
    print.push(unitPrice);
    print.push({ page: secondPage, text: packageQty, x: 468, y: 298 });
    print.push(total);

    if (isTrial) {
      print.push({ page: secondPage, text: 'UPshow Professional Package', x: 40, y: 312 });
      print.push({ page: secondPage, text: packagePrice, x: 394, y: 313 });
      print.push({ page: secondPage, text: packageQty, x: 468, y: 313 });
      print.push({ page: secondPage, text: packagePrice, x: 520, y: 313 });
    }

    // THIRD PARTY CONTENT
    const peacockStartDate = new Date();
    const peacockRollOutDate = new Date();
    peacockRollOutDate.setDate(peacockRollOutDate.getDate() + 30);
    // Contract Start Date
    print.push({ page: thirdPage, text: peacockStartDate.toLocaleDateString(), x: 185, y: 144 });
    // Subscription Term
    print.push({ page: thirdPage, text: isMonthlySubscription ? 'Monthly' : 'Annual', x: 185, y: 158 });
    // Contract Roll out Date
    print.push({ page: thirdPage, text: peacockRollOutDate.toLocaleDateString(), x: 185, y: 173 });

    // THIRD PARTY CONTENT LICENSE RECURRING FEES
    // Description
    print.push({ page: thirdPage, text: 'Peacock Sports Pass', x: 40, y: 254 });
    // FCO
    print.push({ page: thirdPage, text: `${fireCode}`, x: 297, y: 254 });
    // FCO Tier
    print.push({ page: thirdPage, text: getTier(fireCode), x: 342, y: 254 });
    // Unit Price
    print.push({ page: thirdPage, text: `$${fireCodePrice}`, x: 392, y: 254 });
    // Qty
    print.push({ page: thirdPage, text: '1', x: 465, y: 254 });
    // Extended Price
    print.push({ page: thirdPage, text: `$${fireCodePrice}`, x: 520, y: 254 });
    // Total
    print.push({ page: thirdPage, text: `$${fireCodePrice}`, x: 520, y: 283 });
  } else {
    print.push({ page: secondPage, text: packageName, x: 40, y: 298 });
    print.push({ page: secondPage, text: packagePrice, x: 394, y: 298 });
    print.push({ page: secondPage, text: packageQty, x: 468, y: 298 });
    print.push({ page: secondPage, text: packagePrice, x: 520, y: 298 });
  }

  print.push({ page: secondPage, text: packagePrice, x: 520, y: 342 });

  // OTHER CHARGES
  // Unit Price
  print.push({ page: secondPage, text: `$${deviceFinalPrice}`, x: 394, y: 422 });
  // Extended Price
  print.push({ page: secondPage, text: `$${deviceFinalPrice}`, x: 518, y: 422 });
  // Unit Price
  print.push({ page: secondPage, text: `$${shippingFee}`, x: 394, y: 437 });
  // Extended Price
  print.push({ page: secondPage, text: `$${shippingFee}`, x: 518, y: 437 });
  // Total
  print.push({ page: secondPage, text: `$${otherChargesTotal}`, x: 518, y: 465 });
  // Total Order
  print.push({ page: secondPage, text: `$${totalOrder}`, x: 518, y: 502 });

  for (const item of print) {
    const size = item.size || 12;
    const color = item.color || rgb(0, 0, 0);
    addToPage(item.page, item.text, item.x, item.y, helveticaFont, size, color);
  }
  const pdfBytes = await pdfDoc.save();

  return URL.createObjectURL(new Blob([pdfBytes], { type: 'application/pdf' }));
}

const addToPage = (page, value, x, y, font, size, color) => {
  const { height } = page.getSize();
  page.drawText(value, {
    x,
    y: height - y,
    size,
    font,
    color,
  });
};

export default getMSA;
